// 3rd party
import { action, makeObservable, observable } from 'mobx';

// Bernie
import { Store } from 'bernie-plugin-mobx';
import { SerializedData } from 'bernie-core';
import { Logger, NOOP_LOGGER } from 'bernie-logger';

// Utils
import posaList from '../util/posaList';

class UiStore extends Store {
  public cookieConsentBannerEnabled;
  public pageName: string;
  public pzClientId: string;
  public pzRedirectUri: string;
  public osanoURL;
  public osanoUpdateLocale;
  public osanoLoaded: boolean;
  public supportedLocales;
  public flexDocumentPrefix: string;
  public documentName: string;
  public posa: string;
  public signUpUrl: string;
  public signInUrl: string;
  public cpAppUrl: string;
  public resetPwdUrl: string;

  constructor(config, state: SerializedData = {}, protected logger: Logger = NOOP_LOGGER) {
    super(state, logger);

    makeObservable(this, {
      cookieConsentBannerEnabled: observable,
      supportedLocales: observable,
      pageName: observable,
      osanoURL: observable,
      pzClientId: observable,
      pzRedirectUri: observable,
      osanoUpdateLocale: observable,
      osanoLoaded: observable,
      setOsanoLoaded: action,
      setPageName: action,
      flexDocumentPrefix: observable,
      documentName: observable,
      setDocumentName: action,
      posa: observable,
      setPosa: action,
      signUpUrl: observable,
      signInUrl: observable,
      resetPwdUrl: observable,
      cpAppUrl: observable,
    });

    this.supportedLocales = config.app?.supportedLocales;

    this.cookieConsentBannerEnabled = config.app?.osano.enabled;
    this.osanoURL = config.app?.osano.url;
    this.osanoUpdateLocale = config.app?.osano.updateLocale;

    this.flexDocumentPrefix = config.app?.flexDocumentPrefix;

    this.pzClientId = config.secrets?.pzClientID;
    this.pzRedirectUri = config.partnerize?.redirect_uri;

    this.signUpUrl = config.app?.redirect?.signUpUrl;
    this.signInUrl = config.app?.redirect?.signInUrl;
    this.resetPwdUrl = config.app?.redirect?.resetPwdUrl;
    this.cpAppUrl = config.app?.redirect?.cpAppUrl;
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  public setOsanoLoaded(loaded: boolean): void {
    this.osanoLoaded = loaded;
  }

  public setPageName(name: string): void {
    this.pageName = name;
  }

  public setDocumentName(documentName: string): void {
    this.documentName = documentName;
  }

  public setPosa(posa: string): void {
    posa = posa?.toUpperCase();
    posa = posa === 'UK' ? 'GB' : posa;
    posa = posaList.includes(posa) ? posa : 'US';

    this.posa = posa;
    localStorage?.setItem('posa', posa);
  }
}

export { UiStore };
